import React from 'react';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow_down.svg';
import { ReactComponent as Avatar } from '../../assets/icons/avatar.svg';
import { ReactComponent as Bolt } from '../../assets/icons/bolt.svg';
import { ReactComponent as Euro } from '../../assets/icons/euro.svg';
import { ReactComponent as Gear } from '../../assets/icons/gear.svg';
import { ReactComponent as Geo } from '../../assets/icons/geo.svg';
import { ReactComponent as House } from '../../assets/icons/house.svg';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import { ReactComponent as Magnifier } from '../../assets/icons/magnifier.svg';
import { ReactComponent as Menu } from '../../assets/icons/menu.svg';
import { ReactComponent as Polygon } from '../../assets/icons/polygon.svg';
import { ReactComponent as Rectangle } from '../../assets/icons/rectangle.svg';
import { ReactComponent as Sun } from '../../assets/icons/sun.svg';
import { ReactComponent as Wallet } from '../../assets/icons/wallet.svg';

export type IconType =
    | 'arrow_down'
    | 'avatar'
    | 'bolt'
    | 'euro'
    | 'gear'
    | 'geo'
    | 'house'
    | 'info'
    | 'magnifier'
    | 'menu'
    | 'polygon'
    | 'rectangle'
    | 'sun'
    | 'wallet';

interface IconProps {
    icon: IconType;
    styles?: {}
}

export default function Icon({ icon, styles }: IconProps) {
    switch (icon) {
        case 'arrow_down':
            return <ArrowDown style={styles} />;
        case 'avatar':
            return <Avatar />;
        case 'bolt':
            return <Bolt />;
        case 'euro':
            return <Euro />;
        case 'gear':
            return <Gear />;
        case 'geo':
            return <Geo />;
        case 'house':
            return <House style={styles} />;
        case 'info':
            return <Info />;
        case 'magnifier':
            return <Magnifier />;
        case 'menu':
            return <Menu />;
        case 'polygon':
            return <Polygon style={styles} />;
        case 'rectangle':
            return <Rectangle />;
        case 'sun':
            return <Sun />;
        case 'wallet':
            return <Wallet />;

    }
}
